var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chat-centered",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7045",
    "data-name": "Rectangle 7045",
    width: 20,
    height: 20,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_64991",
    "data-name": "Path 64991",
    d: "M41.16,59.511l-1.152,1.922a.63.63,0,0,1-1.074,0l-1.152-1.922a.615.615,0,0,0-.529-.3H32.623A.623.623,0,0,1,32,58.585V48.623A.623.623,0,0,1,32.623,48h13.7a.623.623,0,0,1,.623.623v9.962a.623.623,0,0,1-.623.623H41.69a.615.615,0,0,0-.529.3Z",
    transform: "translate(-29.51 -44.264)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.52db951e5e75fd564f0b60877c1f438d.svg";
export { ForwardRef as ReactComponent };